import { useState } from 'react';
import { Link } from 'react-router-dom';
import PanelLayout from '../components/PanelLayout';
import { requests } from '@/mocks/therapistPanel';

export default function TaleplerPage() {
  const [requestList, setRequestList] = useState(requests);

  const handleAction = (id: number, action: 'accept' | 'decline' | 'later') => {
    setRequestList((prev) =>
      prev.map((r) => (r.id === id ? { ...r, status: action } : r))
    );
  };

  const urgencyColor = (hours: number) => {
    if (hours <= 12) return 'bg-red-50 border-red-200 text-red-600';
    if (hours <= 24) return 'bg-amber-50 border-amber-200 text-amber-600';
    return 'bg-gray-50 border-gray-200 text-gray-500';
  };

  return (
    <PanelLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500">İletişim Talepleri</h1>
          <p className="text-sm text-gray-500 mt-1">
            Size iletişim talebi gönderen spa işletmeleri. Her talep için 72 saat yanıt süreniz bulunur.
          </p>
        </div>

        {/* Limits Info */}
        <div className="bg-dark-teal-50 border border-dark-teal-100 rounded-xl p-4 mb-6 flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-dark-teal-500 shrink-0 mt-0.5">
            <i className="ri-information-line text-base" />
          </span>
          <div>
            <p className="text-sm font-medium text-dark-teal-700">Bekleyen talep limiti: max 10</p>
            <p className="text-xs text-dark-teal-600 mt-0.5">
              Açık sohbet limiti: max 5. Her 24 saatte talep hatırlatma bildirimi gönderilebilir.
            </p>
          </div>
        </div>

        <div className="space-y-4">
          {requestList.map((req) => (
            <div
              key={req.id}
              className={`bg-white rounded-xl border p-5 transition-all ${
                req.status ? 'border-gray-100 opacity-60' : 'border-gray-100'
              }`}
            >
              <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-sm font-semibold text-deep-navy-500">{req.spaType}</span>
                    {req.verified && (
                      <span className="w-4 h-4 flex items-center justify-center text-dark-teal-500">
                        <i className="ri-verified-badge-fill text-xs" />
                      </span>
                    )}
                    {!req.status && (
                      <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium border ${urgencyColor(req.hoursLeft)}`}>
                        {req.hoursLeft} saat kaldı
                      </span>
                    )}
                    {req.status === 'accept' && (
                      <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-green-50 text-green-600">Kabul edildi</span>
                    )}
                    {req.status === 'decline' && (
                      <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 text-gray-500">Uygun Değil</span>
                    )}
                    {req.status === 'later' && (
                      <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-amber-50 text-amber-600">Şu An Müsait Değilim</span>
                    )}
                  </div>

                  <p className="text-xs text-gray-500 mb-3">{req.summary}</p>

                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs text-gray-500">
                    <div className="flex items-center gap-1.5">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-map-pin-line" /></span>
                      {req.city}
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-money-cny-circle-line" /></span>
                      {req.salaryBand}
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-shield-check-line" /></span>
                      SGK: {req.ssg}
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-hotel-bed-line" /></span>
                      {req.accommodation}
                    </div>
                    <div className="flex items-center gap-1.5 col-span-2 sm:col-span-4">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-time-line" /></span>
                      Çalışma saatleri: {req.workHours}
                    </div>
                  </div>
                </div>

                {!req.status && (
                  <div className="flex sm:flex-col gap-2 shrink-0">
                    <button
                      onClick={() => handleAction(req.id, 'accept')}
                      className="px-4 py-2 rounded-lg bg-dark-teal-500 text-white text-xs font-semibold hover:bg-dark-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Kabul Et
                    </button>
                    <button
                      onClick={() => handleAction(req.id, 'decline')}
                      className="px-4 py-2 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Uygun Değil
                    </button>
                    <button
                      onClick={() => handleAction(req.id, 'later')}
                      className="px-4 py-2 rounded-lg bg-amber-50 text-amber-600 text-xs font-medium hover:bg-amber-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Şu An Müsait Değilim
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {requestList.length === 0 && (
          <div className="text-center py-16">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-gray-300 mb-3">
              <i className="ri-mail-line text-3xl" />
            </span>
            <p className="text-sm text-gray-500">Bekleyen iletişim talebi yok.</p>
          </div>
        )}
      </div>
    </PanelLayout>
  );
}